import { ContentCopy } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography, TypographyProps } from "@mui/material";
import { useState } from "react";

interface CopyableTypographyProps extends Partial<TypographyProps> {
	value: string;
	tooltip?: string;
}

export function CopyableTypography({ value, variant = "body2", fontWeight = 400, tooltip = "Copiar", sx, ...rest }: CopyableTypographyProps) {
	const [hovered, setHovered] = useState(false);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(value);
		} catch (err) {
			console.error("Falha ao copiar:", err);
		}
	};

	return (
		<Box display="flex" alignItems="center" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} sx={{ position: "relative" }}>
			<Typography variant={variant} fontWeight={fontWeight} sx={{ pr: 1, wordBreak: "break-word", ...sx }} {...rest}>
				{value}
			</Typography>

			{hovered && (
				<Tooltip title={tooltip}>
					<IconButton size="small" onClick={handleCopy}>
						<ContentCopy fontSize="inherit" />
					</IconButton>
				</Tooltip>
			)}
		</Box>
	);
}
